import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index';

/* 가이드 라인 */
import Guideline from '../html/guideline/Guideline.vue';
import CodingList from '../html/guideline/CodingList.vue';

/* Util */
import SearchList from '../html/subpage/util/SearchList.vue';
import LoginMain from '../html/subpage/util/LoginMain.vue';
import Join from '../html/subpage/util/Join.vue';
import Error from '../html/subpage/util/Error.vue';

import MembershipAgreement from '../html/subpage/util/MembershipAgreement.vue';
import MembershipCertification from '../html/subpage/util/membershipcertification.vue';
import MembershipInfomation from '../html/subpage/util/MembershipInfomation.vue';
import MembershipCompletion from '../html/subpage/util/MembershipCompletion.vue';

import Businessagreement from '../html/subpage/util/Businessagreement.vue';
import BusinessInformation from '../html/subpage/util/BusinessInformation.vue';
import BusinessCompletion from '../html/subpage/util/BusinessCompletion.vue';

/* 공영 주차장 */
import ParkingMap from '../html/subpage/parking/ParkingMap.vue';
import ParkingAddr from '../html/subpage/parking/ParkingAddress.vue';
import ParkFeeInformation from '../html/subpage/parking/ParkFeeInformation.vue';
import ParkFeeReduction from '../html/subpage/parking/ParkFeeReduction.vue';

/* 주차요금 사전정산 */
import PrepaymentInfo from '../html/subpage/prepayment/PrepaymentInfo.vue';
import LookupPayment from '../html/subpage/prepayment/LookupPayment.vue';
import PaymentView from '../html/subpage/prepayment/PaymentView.vue';
import AdvancePayment from '../html/subpage/prepayment/AdvancePayment.vue';

/* 미납주차요금 */
import UnpaidInfo from '../html/subpage/unpaid/UnpaidInfo.vue';
import LookupUnpaid from '../html/subpage/unpaid/LookupUnpaid.vue';
import UnpaidView from '../html/subpage/unpaid/UnpaidView.vue';

/* 공영주차장 정기권 */
import PeriodInfo from '../html/subpage/period/PeriodInfo.vue';
import PeriodApplication from '../html/subpage/period/PeriodApplication.vue';
import PeriodResult from '../html/subpage/period/PeriodResult.vue';
import PeriodLookup from '../html/subpage/period/PeriodLookup.vue';
import PeriodView from '../html/subpage/period/PeriodView.vue';

/* 웹 선불권 */
import WebDiscountCharge from '../html/subpage/webDiscount/webDiscountCharge.vue';
import WebDiscountUse from '../html/subpage/webDiscount/webDiscountUse.vue';
import webDiscountUseView from '../html/subpage/webDiscount/webDiscountUseView.vue';

/* 게시판 */
import NoticeList from '../html/subpage/board/NoticeList.vue';
import NoticeView from '../html/subpage/board/NoticeView.vue';
import FAQView from '../html/subpage/board/FaqView.vue';
import QnaList from '../html/subpage/board/QnaList.vue';
import QnaEnrollment from '../html/subpage/board/QnaEnrollment.vue';
import QnaView from '../html/subpage/board/QnaView.vue';
import QnaAnswerEnrollment from '../html/subpage/board/QnaAnswerEnrollment.vue';

/* 마이 페이지 */
import MypageMain from '../html/subpage/mypage/MypageMain.vue';
import MypageUpdate from '../html/subpage/mypage/MypageUpdate.vue';
import MypagePrepayment from '../html/subpage/mypage/MypagePrepayment.vue';
import MypagePayment from '../html/subpage/mypage/MypagePayment.vue';
import MypageUnpaid from '../html/subpage/mypage/MypageUnpaid.vue';
import MypageDiscountPayment from '../html/subpage/mypage/MypageDiscountPayment.vue';
import MypageDiscount from '../html/subpage/mypage/MypageDiscount.vue';

/* 관리자: 회원관리 */
import GeneralMembership from '../html/manager/member/GeneralMembership.vue';
import GeneralMembershipView from '../html/manager/member/GeneralMembershipView.vue';
import Businessmembership from '../html/manager/member/Businessmembership.vue';
import Businessmembershipview from '../html/manager/member/Businessmembershipview.vue';

/* 관리자: 차량관리 */
import DiscountVehicle from '../html/manager/vehicle/DiscountVehicle.vue';
import DiscountVehicleEnrollment from '../html/manager/vehicle/DiscountVehicleEnrollment.vue';
import DiscountVehicleView from '../html/manager/vehicle/DiscountVehicleView.vue';
import DiscountVehicleUpdate from '../html/manager/vehicle/DiscountVehicleUpdate.vue';
import FreeVehicle from '../html/manager/vehicle/FreeVehicle.vue';
import FreeVehicleView from '../html/manager/vehicle/FreeVehicleView.vue';
import FreeVehicleEnrollment from '../html/manager/vehicle/FreeVehicleEnrollment.vue';
import FreeVehicleUpdate from '../html/manager/vehicle/FreeVehicleUpdate.vue';

/* 관리자: 정기권주차장관리 */
import PeriodParking from '../html/manager/vehicle/PeriodParking.vue';

/** 관리자: 게시판  관리 **/
/* 공지사항 관리 */
import NoticeManagement from '../html/manager/notice/NoticeManagement.vue';
import NoticeManagementView from '../html/manager/notice/NoticeManagementView.vue';
import NoticeManagementEnrollment from '../html/manager/notice/NoticeManagementEnrollment.vue';
import NoticeManagementUpdate from '../html/manager/notice/NoticeManagementUpdate.vue';

/* 자주하는 질문 관리 */
import FaQManagement from '../html/manager/faq/FaQManagement.vue';
import FaQManagementEnrollment from '../html/manager/faq/FaQManagementEnrollment.vue';
import FaQManagementUpdate from '../html/manager/faq/FaQManagementUpdate.vue';
import FaQManagementView from '../html/manager/faq/FaQManagementView.vue';

/** 관리자: 팝업/배너  관리 **/
/* 팝업 관리 */
import PopupList from '../html/manager/popup/PopupList.vue';
import PopupEnrollment from '../html/manager/popup/PopupEnrollment.vue';
import PopupUpdate from '../html/manager/popup/PopupUpdate.vue';
import PopupView from '../html/manager/popup/PopupView.vue';

/* 배너관리 */
import BannerList from '../html/manager/banner/BannerList.vue';
import BannerEnrollment from '../html/manager/banner/BannerEnrollment.vue';
import BannerView from '../html/manager/banner/BannerView.vue';
import BannerUpdate from '../html/manager/banner/BannerUpdate.vue';

/* 시스템 : 사용자 관리 */
import UserManagement from '../html/system/user/UserManagement.vue';
import UserEnrollment from '../html/system/user/UserEnrollment.vue';
import UserView from '../html/system/user/UserView.vue';
import UserUpdate from '../html/system/user/UserUpdate.vue';

/* 시스템 : 팀관리 */
import TeamList from '../html/system/team/TeamList.vue';
import TeamEnrollment from '../html/system/team/TeamEnrollment.vue';
import TeamUpdate from '../html/system/team/TeamUpdate.vue';
import TeamView from '../html/system/team/TeamView.vue';

/* 시스템 : 부서관리 */
import DepartmentList from '../html/system/department/DepartmentList.vue';
import DepartmentEnrollment from '../html/system/department/DepartmentEnrollment.vue';
import DepartmentView from '../html/system/department/DepartmentView.vue';
import DepartmentUpdate from '../html/system/department/DepartmentUpdate.vue';

/* 시스템 : 메뉴관리 */
import MenuList from '../html/system/menu/MenuList.vue';
import MenuEnrollment from '../html/system/menu/MenuEnrollment.vue';
import MenuView from '../html/system/menu/MenuView.vue';
import MenuUpdate from '../html/system/menu/MenuUpdate.vue';
import ConnertMenuStat from '../html/system/menu/ConnertMenuStat.vue';

/* 시스템 : 권한관리 */
import UserAuthorityList from '../html/system/authority/UserAuthorityList.vue';

/* 시스템 : 접속정보 */
import AccessInfo from '../html/system/access/AccessInfo.vue';
import axios from 'axios';

Vue.use(VueRouter);

export const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/main',
    },

    // 가이드 라인
    {
      path: '/guideline',
      component: Guideline,
    },
    {
      path: '/codinglist',
      name: 'codinglist',
      component: CodingList,
    },

    // 메인페이지
    {
      path: '/main',
      name: 'main',
      component: () => import('../html/mainpage/index.vue'),
      meta: { category: ['메인', '메인'] },
    },

    // Util
    {
      path: '/searchlist',
      component: SearchList,
      meta: {
        category: ['검색결과', '검색결과'],
      },
    },

    {
      path: '/loginmain',
      name: 'loginmain',
      component: LoginMain,
      meta: {
        onlyGuest: true,
      },
    },
    {
      path: '/join',
      name: 'join',
      component: Join,
      meta: {
        onlyGuest: true,
      },
    },
    // 개인정보 수집 동의
    {
      path: '/membershipagreement',
      component: MembershipAgreement,
      name: 'membershipagreement',
      meta: {
        category: ['회원가입', '회원가입(일반)'],
        onlyGuest: true,
      },
    },
    // 본인인증
    {
      path: '/membershipcertification',
      component: MembershipCertification,
      name: 'membershipcertification',
      meta: {
        category: ['회원가입', '본인인증'],
        onlyGuest: true,
      },
    },
    // 회원가입 입력란
    {
      path: '/membershipinfomation',
      name: 'membershipinfomation',
      component: MembershipInfomation,
      meta: {
        category: ['회원가입', '정보입력'],
      },
    },
    {
      path: '/membershipcompletion',
      component: MembershipCompletion,
      meta: {
        category: ['회원가입', '가입완료'],
        // onlyGuest : true,
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
      },
    },
    // 회원가입 사업자
    {
      path: '/businessagreement',
      component: Businessagreement,
      meta: {
        category: ['회원가입', '회원가입(사업자)'],
      },
    },
    {
      path: '/businessinformation',
      component: BusinessInformation,
      meta: {
        category: ['회원가입', '회원가입(사업자)'],
      },
    },
    {
      path: '/businesscompletion',
      component: BusinessCompletion,
      meta: {
        category: ['회원가입', '회원가입(사업자)'],
      },
    },
    {
      path: '/error',
      component: Error,
      meta: {
        category: ['에러페이지', '에러페이지'],
      },
    },

    // 공영주차장
    {
      path: '/map',
      component: ParkingMap,
      name: 'map',
      meta: {
        category: ['공영주차장', '지도 검색'],
      },
    },
    {
      path: '/list',
      component: ParkingAddr,
      name: 'list',
      props: true,
      meta: {
        category: ['공영주차장', '주소 검색'],
      },
    },
    {
      path: '/parkfeeinformation',
      component: ParkFeeInformation,
      meta: {
        category: ['공영주차장', '주차장 이용안내'],
      },
    },
    {
      path: '/parkfeereduction',
      component: ParkFeeReduction,
      meta: {
        category: ['공영주차장', '주차요금 감면안내'],
      },
    },

    // 주차요금 사전정산
    // 1. 안내
    {
      path: '/prepaymentinfo',
      component: PrepaymentInfo,
      meta: {
        category: ['주차요금 사전결제', '안내'],
      },
    },
    // 2. 조회
    {
      path: '/lookup',
      component: LookupPayment,
      name: 'lookup',
      props: true,
      meta: {
        category: ['주차요금 사전결제', '조회/결제'],
      },
    },
    // 3. 상세보기 및 결제
    {
      path: '/paymentview',
      component: PaymentView,
      name: 'paymentview',
      props: true,
      meta: {
        category: ['주차요금 사전결제', '조회/결제'],
      },
    },
    // {
    //   path: '/advancepayment',
    //   component: AdvancePayment,
    //   meta: {
    //     category: ['주차요금 간편조회', '주차요금 간편계산'],
    //   },
    // },

    // 미납주차요금
    // 1. 안내
    {
      path: '/unpaidinfo',
      component: UnpaidInfo,
      meta: {
        category: ['미납주차요금', '안내'],
      },
    },
    // 2. 조회
    {
      path: '/lookupunpaid',
      component: LookupUnpaid,
      name: 'lookupunpaid',
      props: true,
      meta: {
        category: ['미납주차요금', '조회/결제'],
      },
    },
    // 3. 상세보기 및 결제
    {
      path: '/unpaidview',
      component: UnpaidView,
      name: 'unpaidview',
      props: true,
      meta: {
        category: ['미납주차요금', '조회/결제'],
      },
    },

    // 주차서비스 정기권
    // 1. 안내
    {
      path: '/periodinfo',
      component: PeriodInfo,
      meta: {
        category: ['정기권', '정기권 안내'],
      },
    },
    // 2. 신청
    {
      path: '/periodapplication',
      component: PeriodApplication,
      meta: {
        category: ['정기권', '정기권 신청'],
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
        empcategory: ['USR'],
      },
    },
    // 3. 신청 결과
    {
      path: '/periodresult',
      component: PeriodResult,
      name: 'periodresult',
      meta: {
        category: ['정기권', '정기권 신청'],
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
        empcategory: ['USR'],
      },
    },
    // 4. 조회
    {
      path: '/periodlookup',
      component: PeriodLookup,
      name: 'periodlookup',
      props: true,
      meta: {
        category: ['정기권', '정기권 조회/결제'],
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
        empcategory: ['USR'],
      },
    },
    // 5. 상세보기 및 결제
    {
      path: '/periodview',
      component: PeriodView,
      name: 'periodview',
      props: true,
      meta: {
        category: ['정기권', '정기권 조회/결제'],
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
        empcategory: ['USR'],
      },
    },

    // 웹 선불권
    // 1. 웹 선불권 충전
    {
      path: '/webdiscountcharge',
      component: WebDiscountCharge,
      meta: {
        category: ['웹 선불권', '웹 선불권 충전'],
        authorization: ['ROLE_STORE', 'ROLE_ADMIN'],
        empcategory: ['BSN'],
      },
    },
    // 2. 웹 선불권 사용
    {
      path: '/webdiscountuse',
      component: WebDiscountUse,
      meta: {
        category: ['웹 선불권', '웹 선불권 사용'],
        authorization: ['ROLE_STORE', 'ROLE_ADMIN'],
        empcategory: ['BSN'],
      },
    },
    // 2. 웹 선불권 사용 - 상세
    {
      path: '/webdiscountuseview',
      component: webDiscountUseView,
      name: 'webdiscountuseview',
      meta: {
        category: ['웹 선불권', '웹 선불권 사용'],
        authorization: ['ROLE_STORE', 'ROLE_ADMIN'],
        empcategory: ['BSN'],
      },
    },

    // 정보마당
    // 공지사항
    {
      path: '/noticelist',
      component: NoticeList,
      meta: {
        category: ['정보마당', '공지사항'],
      },
    },
    // 공지사항 상세
    {
      path: '/noticeview',
      component: NoticeView,
      meta: {
        category: ['정보마당', '공지사항'],
      },
    },
    // 자주묻는 질문
    {
      path: '/faqview',
      component: FAQView,
      meta: {
        category: ['정보마당', '자주하는 질문'],
      },
    },
    // 묻고답하기
    {
      path: '/qnalist',
      component: QnaList,
      meta: {
        category: ['정보마당', '묻고답하기'],
      },
    },
    // 묻고답하기 등록
    {
      path: '/qnaenrollment',
      component: QnaEnrollment,
      meta: {
        category: ['정보마당', '묻고답하기'],
      },
    },
    // 묻고답하기 상세
    {
      path: '/qnaview',
      component: QnaView,
      meta: {
        category: ['정보마당', '묻고답하기'],
      },
      name: 'qnaView',
    },
    // 묻고답하기 답변 등록 (관리자 로그인 시)
    {
      path: '/qnaanswerenrollment',
      component: QnaAnswerEnrollment,
      meta: {
        category: ['정보마당', '묻고답하기'],
      },
    },

    // 마이페이지
    {
      path: '/mypagemain',
      component: MypageMain,
      meta: {
        category: ['마이페이지', '회원정보'],
      },
    },
    {
      path: '/mypageupdate',
      component: MypageUpdate,
      name: 'mypageupdate',
      meta: {
        category: ['마이페이지', '회원정보 수정'],
      },
    },
    {
      path: '/mypageprepayment',
      component: MypagePrepayment,
      meta: {
        category: ['마이페이지', '서비스 이용내역'],
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
        empcategory: ['USR'],
      },
    },
    {
      path: '/mypagepayment',
      component: MypagePayment,
      meta: {
        category: ['마이페이지', '서비스 이용내역'],
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
        empcategory: ['USR'],
      },
    },
    {
      path: '/mypageunpaid',
      component: MypageUnpaid,
      meta: {
        category: ['마이페이지', '서비스 이용내역'],
        authorization: ['ROLE_USER', 'ROLE_ADMIN'],
        empcategory: ['USR'],
      },
    },
    {
      path: '/mypagediscountpayment',
      component: MypageDiscountPayment,
      meta: {
        category: ['마이페이지', '주차할인권'],
        authorization: ['ROLE_STORE', 'ROLE_ADMIN'],
        empcategory: ['BSN'],
      },
    },
    {
      path: '/mypagediscount',
      component: MypageDiscount,
      meta: {
        category: ['마이페이지', '주차할인권'],
        authorization: ['ROLE_STORE', 'ROLE_ADMIN'],
        empcategory: ['BSN'],
      },
    },

    // 관리자 메뉴 : 회원 관리
    //일반회원
    {
      path: '/generalmembership',
      component: GeneralMembership,
      meta: {
        category: ['관리자 메뉴', '회원 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    //일반회원 상세정보
    {
      path: '/generalmembershipview',
      component: GeneralMembershipView,
      meta: {
        category: ['관리자 메뉴', '회원 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    //사업자회원
    {
      path: '/businessmembership',
      component: Businessmembership,
      meta: {
        category: ['관리자 메뉴', '회원 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    //사업자회원 상세정보
    {
      path: '/businessmembershipview',
      component: Businessmembershipview,
      meta: {
        category: ['관리자 메뉴', '회원 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    // 관리자 메뉴 : 차량관리
    {
      path: '/discountvehicle',
      component: DiscountVehicle,
      meta: {
        category: ['관리자 메뉴', '할인차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/discountvehicleenrollment',
      component: DiscountVehicleEnrollment,
      meta: {
        category: ['관리자 메뉴', '할인차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/discountvehicleview',
      component: DiscountVehicleView,
      meta: {
        category: ['관리자 메뉴', '할인차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/discountvehicleupdate',
      component: DiscountVehicleUpdate,
      name: 'discountvehicleupdate',
      meta: {
        category: ['관리자 메뉴', '할인차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/freevehicle',
      component: FreeVehicle,
      meta: {
        category: ['관리자 메뉴', '무료차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/freevehicleview',
      component: FreeVehicleView,
      meta: {
        category: ['관리자 메뉴', '무료차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/freevehicleenrollment',
      component: FreeVehicleEnrollment,
      meta: {
        category: ['관리자 메뉴', '무료차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/freevehicleupdate',
      component: FreeVehicleUpdate,
      name: 'freevehicleupdate',
      meta: {
        category: ['관리자 메뉴', '무료차량 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    // 관리자 메뉴 : 정기권 주차장 관리
    {
      path: '/periodparking',
      component: PeriodParking,
      meta: { category: ['관리자 메뉴', '정기권주차장관리'], authorization: ['ROLE_ADMIN'] },
    },

    // 관리자 메뉴 : 게시판 관리
    {
      path: '/noticemanagement',
      component: NoticeManagement,
      meta: {
        category: ['관리자 메뉴', '공지사항 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/noticemanagementview',
      component: NoticeManagementView,
      meta: {
        category: ['관리자 메뉴', '공지사항 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/noticemanagementenrollment',
      component: NoticeManagementEnrollment,
      meta: {
        category: ['관리자 메뉴', '공지사항 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/noticemanagementupdate',
      component: NoticeManagementUpdate,
      name: 'noticemanagementupdate',
      meta: {
        category: ['관리자 메뉴', '공지사항 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    // 관리자 메뉴 : 자주하는 질문 관리
    {
      path: '/faqmanagement',
      component: FaQManagement,
      meta: {
        category: ['관리자 메뉴', '자주하는 질문 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/faqmanagementview',
      component: FaQManagementView,
      meta: {
        category: ['관리자 메뉴', '자주하는 질문 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/faqmanagementenrollment',
      component: FaQManagementEnrollment,
      meta: {
        category: ['관리자 메뉴', '자주하는 질문 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/faqmanagementupdate',
      component: FaQManagementUpdate,
      name: 'faqmanagementupdate',
      meta: {
        category: ['관리자 메뉴', '자주하는 질문 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    // 관리자 메뉴 : 팝업 관리
    {
      path: '/popuplist',
      component: PopupList,
      meta: {
        category: ['관리자 메뉴', '팝업 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/popupenrollment',
      component: PopupEnrollment,
      meta: {
        category: ['관리자 메뉴', '팝업 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/popupupdate',
      component: PopupUpdate,
      name: 'popupupdate',
      meta: {
        category: ['관리자 메뉴', '팝업 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/popupview',
      component: PopupView,
      meta: {
        category: ['관리자 메뉴', '팝업 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    // 관리자 메뉴 : 배너 관리
    {
      path: '/bannerlist',
      component: BannerList,
      meta: {
        category: ['관리자 메뉴', '배너 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/bannerenrollment',
      component: BannerEnrollment,
      meta: {
        category: ['관리자 메뉴', '배너 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/bannerview',
      component: BannerView,
      meta: {
        category: ['관리자 메뉴', '배너 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/bannerupdate',
      component: BannerUpdate,
      name: 'bannerupdate',
      meta: {
        category: ['관리자 메뉴', '배너 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    // 시스템 관리 : 사용자 관리
    {
      path: '/usermanagement',
      component: UserManagement,
      meta: {
        category: ['시스템 관리', '사용자 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/userenrollment',
      component: UserEnrollment,
      meta: {
        category: ['시스템 관리', '사용자 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/userview',
      component: UserView,
      meta: {
        category: ['시스템 관리', '사용자 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/userupdate',
      component: UserUpdate,
      name: 'userupdate',
      meta: {
        category: ['시스템 관리', '사용자 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    //시스템관리 : 팀관리
    {
      path: '/teamlist',
      component: TeamList,
      meta: {
        category: ['시스템 관리', '팀 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/teamenrollment',
      component: TeamEnrollment,
      meta: {
        category: ['시스템 관리', '팀 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/teamview',
      component: TeamView,
      meta: {
        category: ['시스템 관리', '팀 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/teamupdate',
      component: TeamUpdate,
      name: 'teamupdate',
      meta: {
        category: ['시스템 관리', '팀 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    //시스템관리 : 부서관리
    {
      path: '/departmentlist',
      component: DepartmentList,
      meta: {
        category: ['시스템 관리', '부서 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/departmentenrollment',
      component: DepartmentEnrollment,
      meta: {
        category: ['시스템 관리', '부서 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/departmentview',
      component: DepartmentView,
      name: 'departmentview',
      meta: {
        category: ['시스템 관리', '부서 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/departmentupdate',
      component: DepartmentUpdate,
      name: 'departmentupdate',
      meta: {
        category: ['시스템 관리', '부서 관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    //시스템관리 : 메뉴관리
    {
      path: '/menulist',
      component: MenuList,
      meta: {
        category: ['시스템 관리', '메뉴관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/menuenrollment',
      component: MenuEnrollment,
      meta: {
        category: ['시스템 관리', '메뉴관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/menuview',
      component: MenuView,
      meta: {
        category: ['시스템 관리', '메뉴관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },
    {
      path: '/menuupdate',
      component: MenuUpdate,
      meta: {
        category: ['시스템 관리', '메뉴관리'],
        authorization: ['ROLE_ADMIN'],
      },
    },

    //시스템관리 : 사용자 권한 관리
    {
      path: '/userauthoritylist',
      component: UserAuthorityList,
      meta: {
        category: ['시스템 관리', '사용자 권한 관리'],
        authorization: ['ROLE_STORE', 'ROLE_ADMIN'],
      },
    },

    //시스템관리 : 사용자 접속정보
    {
      path: '/accessinfo',
      component: AccessInfo,
      meta: {
        category: ['시스템 관리', '접속정보'],
        authorization: ['ROLE_STORE', 'ROLE_ADMIN'],
      },
    },
    // 시스템관리 : 메뉴 접속 통계
    // {
    //   path: '/connertmenustat',
    //   component: ConnertMenuStat,
    // },
    {
      path: '/404',
      name: 'notFound',
      component: Error,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isLogin = store.state.isLogin;
  const authorCode = store.state.authorCode;
  const empDiv = store.state.empDiv;
  const { authorization, empcategory } = to.meta;

  if (to.matched.some(record => record.meta.authorization)) {
    if (authorCode === 'ROLE_ADMIN') {
      next();
      return;
    }
  }

  if (to.matched.some(record => record.meta.authorization)) {
    if (!isLogin) {
      alert('로그인이 필요한 서비스입니다.');
      next({ path: '/loginmain' });
      return;
    }

    if (!authorization.includes(authorCode)) {
      alert('접근 권한이 존재하지 않습니다.');
      return;
    }
  }

  if (to.matched.some(record => record.meta.empcategory)) {
    if (!empcategory.includes(empDiv)) {
      alert('접근 권한이 존재하지 않습니다.');
      return;
    }
  }

  if (to.matched.some(record => record.meta.onlyGuest)) {
    if (isLogin) {
      return next({ path: '/main' });
    }
  }

  next();
});

router.afterEach((to, from) => {
  const requestData = {
    visitedPathName : window.location.pathname, 
    visitedCategory : to.meta.category
  }
  addVisitInfo(requestData);
});

function addVisitInfo(requestData) {
  axios.post('/api/visitInfo', requestData);
}